import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";
import swal from "sweetalert";
import requests from "./base";

const ActionDropdownVendor = ({ userid, onStatusUpdated }) => {
  const [open, setOpen] = useState(false);
  const [selectedStatusText, setSelectedStatusText] = useState("");

  // Mapping: Display Text -> Status Integer
  const statusOptions = [
    { label: "System Admin", value: 1 },
    { label: "Products Approver", value: 2 },
    { label: "User Accounts Approver", value: 3 },
    { label: "Vendor", value: 4 },
  ];

  const handleUpdate = async () => {
    if (!selectedStatusText) {
      swal("Error", "Please select a status", "error");
      return;
    }

    const selectedOption = statusOptions.find(
      (option) => option.label === selectedStatusText
    );

    if (!selectedOption) {
      swal("Error", "Invalid status selected", "error");
      return;
    }

    try {
      const response = await requests.post(
        `/UpdateusertypeById?vendorid=${userid}&usertype=${selectedOption.value}`
      );

      if (response) {
        if (response.ResponseCode === 1) {
          swal("Success", response.ResponseMessage, "success");
          if (onStatusUpdated) {
            onStatusUpdated(); // refresh table
          }
        } else if (response.ResponseCode === 2) {
          swal("Error", response.ResponseMessage, "error");
        } else {
          swal("Error", "Unexpected server response", "error");
          console.warn("Unexpected response:", response);
        }
      }
    } catch (error) {
      console.error("Update failed:", error);
      swal("Error", "Failed to update order", "error");
    } finally {
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        style={{ color: "white", backgroundColor: "Grey" }}
        onClick={() => setOpen(true)}
      >
        Update
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Update User</DialogTitle>
        <DialogContent>
          <Typography>Select the new User Type:</Typography>
          <RadioGroup
            value={selectedStatusText}
            onChange={(e) => setSelectedStatusText(e.target.value)}
          >
            {statusOptions.map((status) => (
              <FormControlLabel
                key={status.value}
                value={status.label}
                control={<Radio />}
                label={status.label}
              />
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpen(false)}
            style={{ color: "red", objectFit: "contain" }}
          >
            Cancel
          </Button>
          <Button onClick={handleUpdate} variant="contained" color="primary">
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ActionDropdownVendor;
